import { createSelector } from 'reselect'

const getSelectedNoteId = state => state.note.selectedNoteId
const getDecryptedNotes = state => state.notes.decryptedNotes

export default createSelector(
  getSelectedNoteId,
  getDecryptedNotes,
  (selectedNoteId, decryptedNotes) => ({
    noteId: selectedNoteId,
    note: decryptedNotes[selectedNoteId]
  })
)



// WEBPACK FOOTER //
// ./src/selectors/selectedNote.js